import React, { type JSX } from 'react';
import clsx from 'clsx';
import { CirclePause, PhoneForwarded } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface Props {
  className?: string;
  isTransfer?: boolean;
}

export default function PausedSessionScreen ({ className, isTransfer }: Props): JSX.Element {
  const { t } = useTranslation();

  const transfer = Boolean(isTransfer);
  const Icon = transfer ? PhoneForwarded : CirclePause;

  return (
    <div className={clsx('flex flex-1 min-h-0 flex-col', className)}>
      <div className="flex-1 grid place-items-center">
        <div className="flex flex-col items-center gap-6">
          <div
            className={clsx(
              'relative h-36 w-36 md:h-44 md:w-44 rounded-full flex items-center justify-center',
              'bg-card border-2 shadow-xl',
              transfer ? 'border-blue-500/30' : 'border-amber-500/30',
            )}
          >
            <div className={clsx(
              'absolute inset-0 rounded-full ring-[12px] md:ring-[20px]',
              transfer ? 'ring-blue-500/15' : 'ring-amber-500/15',
            )} />
            <Icon
              className={clsx('!h-10 !w-10 md:!h-12 md:!w-12', transfer ? 'text-blue-500' : 'text-amber-500')}
              strokeWidth={1.5}
            />
          </div>
          <div className="flex flex-col items-center gap-2 text-center px-4">
            <h2 className="text-xl md:text-2xl font-bold text-foreground">
              {t('agentLayout.sessionPaused', 'Session Paused')}
            </h2>
            <p className="text-sm md:text-base text-muted-foreground max-w-sm">
              {transfer
                ? t('agentLayout.sessionPausedTransfer', 'SDR is on a transferred call. The session will resume once the transfer ends.')
                : t('agentLayout.sessionPausedMessage', 'The SDR has paused the session. It will resume shortly.')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
